module.exports = "### ToolbarTitle Properties\n\nA simple text that is displayed in the `Toolbar`.\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Toolbar/ToolbarTitle.md
 ** module id = 1095
 ** module chunks = 0
 **/